/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Link } from "react-router-dom";

import type { FC, PropsWithChildren } from "react";

type Props = {
  href: string;
};

export const CardLink: FC<PropsWithChildren<Props>> = (props) => {
  const { children, href } = props;

  return (
    <Link css={rootStyle} to={href}>
      {children}
    </Link>
  );
};

const rootStyle = css`
  display: block;
  height: 100%;
`;
